<script>
    import { onMount } from "svelte";
    import WorkCoverAuthorities from "../../Pages/WorkCoverAuthorities/WorkCoverAuthorities.svelte";
    import { checkTokenExpiration } from "../../Utils/utilFunctions.svelte";

    export let tokenRefresh = undefined;
    export let params;

    onMount(async () => {
        tokenRefresh = checkTokenExpiration();
    });
</script>

{#await tokenRefresh then tokenRefreshResult}
    {#if tokenRefreshResult === "valid" || tokenRefreshResult === "refreshed"}
        <div class="flex flex-1 flex-col w-full px-6 py-4 bg-gray-200">
            <WorkCoverAuthorities {params} />
        </div>
    {/if}
{/await}
